import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'report',
    path: 'last_execution',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (!value) return
    change(value)
  }
}
